import * as React from 'react';
import { Container } from 'types/Watchlist';
import { Demurrage } from './Demurrage';
import { Holds } from './Holds';
import { Pickup } from './Pickup';

interface Props {
  container: Container;
}

export const Availability: React.FC<Props> = (props) => {
  const { container } = props;
  return (
    <div className="p-4">
      <Pickup container={container} />
      <Demurrage container={container} />
      <Holds container={container} />
    </div>
  );
};
Availability.displayName = 'Shipments.DetailDrawer.Sections.Availability';
